/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronsDoubleLeft: {
  name: 'chevrons-double-left';
  data: string;
} = {
  name: 'chevrons-double-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.707 8.707a1 1 0 0 0-1.414-1.414l-4 4a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414-1.414L8.414 12l3.293-3.293Zm6 0a1 1 0 0 0-1.414-1.414l-4 4a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414-1.414L14.414 12l3.293-3.293Z" fill="currentColor"/></svg>`,
};
